module.exports = __webpack_public_path__ + "static/media/lock-screen.d219c746.jpg";